/**
 * Russia-only address field validation + phone normalization.
 * Copied from apps/web/lib/address-validation.ts (same logic, no web deps).
 */

export const RU_REGION_CODE = "+7";
export const RU_COUNTRY_CODE = "RU";
export const RU_COUNTRY_TEXT = "Россия";

function digitsOnly(input: string): string {
  return input.replace(/\D/g, "");
}

export function normalizeRuMobileDigits(input: string): string | null {
  let d = digitsOnly(input);
  if (d.length === 11 && (d.startsWith("7") || d.startsWith("8"))) {
    d = d.slice(1);
  }
  if (d.length !== 10) return null;
  if (!d.startsWith("9")) return null;
  return d;
}

export function toRuMobileE164(input: string): string | null {
  const d = normalizeRuMobileDigits(input);
  return d === null ? null : `+7${d}`;
}

export function formatRuMobileDisplay(mobile: string): string {
  const national = normalizeRuMobileDigits(mobile);
  if (national === null) return mobile.trim();
  return `${RU_REGION_CODE} ${national.slice(0, 3)} ${national.slice(3, 6)} ${national.slice(6, 8)} ${national.slice(8)}`;
}

export function isValidRuPostalCode(input: string): boolean {
  return /^\d{6}$/.test(input.trim());
}
